import { useActivityFormStore } from "PFApp/activities/activity_form/activity_form_store";
import { useMatchAttributeSidepanel } from "PFApp/hooks/activity_form/use_match_attribute_sidepanel";
import { Stack } from "PFComponents/containers";
import { Tip } from "PFComponents/text/input_field_set/components/tip";
import { isRankable } from "PFCore/helpers/custom_type";
import { activityCustomTypesAccessLevels } from "PFCore/helpers/custom_types";
import { useCurrentProfile } from "PFCore/hooks/queries/profile";
import { AccessLevel, Profile } from "PFCore/types";

import { CustomFieldComponentProps } from "../component_prop_types";
import { MatchAttributeFieldBox } from "./parts/match_attribute_field_box";
import { MatchAttributeFieldHeader } from "./parts/match_attribute_field_header";

type MatchAttributeFieldProps = Omit<CustomFieldComponentProps, "property"> & {
  isMultiple: boolean;
  activityCreator: Profile | null;
};

export const MatchAttributeField = ({
  label,
  value,
  required,
  disabled,
  customType,
  connectedValuesIds,
  isMultiple,
  activityCreator,
  error,
  tip,
  onChange,
  onClear,
  onRestore
}: MatchAttributeFieldProps) => {
  const { data: currentProfile } = useCurrentProfile();

  const template = useActivityFormStore((state) => state.template);
  const isSkills = customType.name === "skills";

  const accessLevel = activityCustomTypesAccessLevels(currentProfile, activityCreator ?? null)[customType.id];
  const locked = accessLevel !== AccessLevel.ReadWrite;
  const { handleSidePanelOpen } = useMatchAttributeSidepanel({
    value,
    customType,
    isMultiple,
    template,
    activityCreator,
    connectedValuesIds,
    onChange
  });

  return (
    <Stack>
      <MatchAttributeFieldHeader
        label={label || ""}
        required={!!required}
        locked={locked}
        onAdd={() => handleSidePanelOpen()}
        onClear={value.length > 0 ? onClear : undefined}
        onRestore={onRestore}
        actionsDisabled={disabled}
        addDisabled={disabled}
      />
      <MatchAttributeFieldBox
        allowToAdd={isSkills}
        customType={customType}
        activityCreator={activityCreator}
        connectedValuesIds={connectedValuesIds}
        value={value}
        isRankable={isRankable(customType)}
        disabled={disabled || locked}
        onValueClick={handleSidePanelOpen}
        hasError={!!error}
        onChange={onChange}
      />
      {(error || tip) && <Tip error={error} tip={tip} />}
    </Stack>
  );
};
